import { Data, isDataLoaded, makeLoadedData, ExtractDataType } from '../../types/data-providers';
import * as SiteManager from '../domain/site-manager';
import React from 'react';
import { useData, dataFromDataset } from './DataProviderCache';
import { useAuthHelper } from '../../components/AuthContextProvider';

type ContextState = Data<{
    offlinedevicecount: number | undefined;
    status: boolean | undefined | null;
}>;


const Context = React.createContext<ContextState | null>(null);


function useSiteOnlineStatusData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSiteOnlineData must be used within a SiteOnlineStatusDataProvider');
    }
    return contextState;  
}

const SiteOnlineStatusDataProvider: React.FC<{ siteId: string }> = (props) => {
    const authHelper = useAuthHelper();

    const { dataset } = useData({
        cacheKey: 'site-online-data',
        id: props.siteId,
        dataFn: React.useCallback(
            () => SiteManager.getOnlineStatus(authHelper, { siteId: props.siteId }),
            [authHelper, props.siteId]
        ),
    });
    const statusData = dataFromDataset(dataset);

    const value = React.useMemo(() => {
        if (!isDataLoaded(statusData)) {
            return statusData;
        }

        return makeLoadedData<ExtractDataType<ContextState>>({
            // ...statusData.value,
         status:statusData.value.status,
         offlinedevicecount:statusData.value.offlinedevicecount,
            
        });
    }, [statusData]);
   
    return <Context.Provider value={value}>{props.children}</Context.Provider>;
};

const TestSiteOnlineStatusDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);


export { SiteOnlineStatusDataProvider, TestSiteOnlineStatusDataProvider, useSiteOnlineStatusData };


